import { PROVIDER_CONNECTION_TYPE } from "../misc";
import React, { useMemo } from "react";
import {
    useCategoryContext,
    useProviderComparePageContext,
    useProviderInfoPageContext
} from "../../Components/Context";
import { Paragraph } from "../../Components/Paragraph";

export const CategoryDescription: React.FC<{}> = () => {
    const { category } = useCategoryContext();
    const { provider } = useProviderInfoPageContext();
    const { provider: comparisonProvider, toProvider: comparisonToProvider } = useProviderComparePageContext();

    const description = useMemo(() => {
        return category?.description;
    }, [category]);

    const bulkProviderDescription = useMemo(() => {
        const providers = [provider, comparisonProvider, comparisonToProvider].filter(d => d != null);
        const allBulks =
            providers?.length > 0 &&
            providers.filter(d => d?.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk)?.length ===
                providers?.length;

        return allBulks ? category?.bulkProviderDescription : null;
    }, [category, provider, comparisonProvider, comparisonToProvider]);

    const categoryDescriptionReplace = useMemo(() => {
        return category?.replaceWhenBulks == null ? false : true;
    }, [category]);

    if (
        // not replace but description and the addition description don't exist
        (!categoryDescriptionReplace && !description && !bulkProviderDescription) ||
        // replace mode but the addition description doesn't exist
        (categoryDescriptionReplace && !description && !bulkProviderDescription)
    )
        return null;

    return (
        <>
            {categoryDescriptionReplace === false && (
                <>
                    {description != null && <Paragraph nid={-1} title={""} status={true} text={description} />}

                    {description != null && bulkProviderDescription != null && <br />}

                    {bulkProviderDescription != null && (
                        <Paragraph nid={-1} title={""} status={true} text={bulkProviderDescription} />
                    )}
                </>
            )}
            {categoryDescriptionReplace === true && (
                <>
                    {description != null &&
                        (bulkProviderDescription == null || bulkProviderDescription?.value?.trim() === "") && (
                            <Paragraph nid={-1} title={""} status={true} text={description} />
                        )}
                    {bulkProviderDescription != null && (
                        <Paragraph nid={-1} title={""} status={true} text={bulkProviderDescription} />
                    )}
                </>
            )}
        </>
    );
};
